<template>
  <div class="page" v-loading="loading">
    <el-form :model="form" :rules="rules" ref="form" label-width="90px">
      <el-form-item label-width="0">
        <h2>提现</h2>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="提现金额" prop="amount">
            <el-input v-model="form.amount" placeholder="请输入"></el-input>
            <span>可提现余额：¥{{ accountDetail.balance }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="提现至">
            <el-card shadow="never" class="card">
              <el-form-item label="银行账号：">{{ suppliersDetail.bankAccount }}</el-form-item>
              <el-form-item label="账户名称：">{{ suppliersDetail.accountName }}</el-form-item>
              <el-form-item label="银行名称：">{{ suppliersDetail.accountsBank }}</el-form-item>
              <el-form-item label="联行号：">{{ suppliersDetail.cnapsCode || "暂无" }}</el-form-item>
              <!-- <el-form-item label="所属支行：">{{ suppliersDetail.accountsBank }}</el-form-item> -->
            </el-card>
            <!-- <el-card shadow="never" class="card" v-else>
              <el-form-item>
                <p style="text-align: center;padding:30px 0 ;">请先联系相关负责人添加您的对公账户</p>
              </el-form-item>
            </el-card> -->
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="提现密码" prop="passWord">
            <el-input v-model="form.passWord" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" @click="handleSubmit"
          :disabled="!(suppliersDetail.bankAccount && suppliersDetail.accountName && suppliersDetail.accountsBank && suppliersDetail.cnapsCode)">确认提现</el-button>
      </el-form-item>
    </el-form>
    <!-- <el-dialog title="添加/更换对公账户" :visible.sync="bankInfoVisible" width="40%" :before-close="bankInfoClose">
      <el-form :model="bankInfo" :rules="bankInfoRule" ref="bankInfoForm" label-width="100px">
        <el-form-item label="银行账号" prop="a">
          <el-input v-model="bankInfo.a"></el-input>
        </el-form-item>
        <el-form-item label="账户名称" prop="a">
          <el-input v-model="bankInfo.a"></el-input>
        </el-form-item>
        <el-form-item label="银行名称" prop="a">
          <el-input v-model="bankInfo.a"></el-input>
        </el-form-item>
        <el-form-item label="所属支行" prop="a">
          <el-input v-model="bankInfo.a"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="bankInfoClose">取 消</el-button>
        <el-button type="primary" @click="bankInfoSure">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import {
  KSAXWalletAccountDetail,
  KSAXSuppliersDetail,
  KSAXWithdrawalApplication
} from "../../../api/api";
export default {
  data() {
    var validateAmount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入'));
      } else if (isNaN(Number(value))) {
        return callback(new Error('请输入数字'));
      } else if (value > this.accountDetail.balance) {
        return callback(new Error('提现金额不可超过可用余额'));
      } else {
        return callback();
      }
    };
    return {
      loading: false,
      accountDetail: {},
      suppliersDetail: {},
      form: {
        supId: this.$route.query.id,
        amount: null,
        passWord: null,
      },
      rules: {
        amount: [
          { validator: validateAmount, required: true, trigger: 'blur' },
        ],
        passWord: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
      },
      // bankInfo: {
      //   a: null
      // },
      // bankInfoRule: {
      //   a: [
      //     { required: true, message: '请输入', trigger: 'blur' },
      //   ],
      // },
      // bankInfoVisible: false
    };
  },
  created() {
    KSAXWalletAccountDetail({ resellerId: this.$route.query.id }).then(res => {
      if (res.data.result.success) {
        this.accountDetail = res.data.result.data
      } else {
        this.$message.error(res.data.result.message)
      }
    })
    KSAXSuppliersDetail({ resellerId: this.$route.query.id }).then(res => {
      if (res.data.result.success) {
        this.suppliersDetail = res.data.result.data
      } else {
        this.$message.error(res.data.result.message)
      }
    })
  },
  mounted() {

  },
  methods: {
    handleSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loading = true
          KSAXWithdrawalApplication(this.form).then(res => {
            if (res.data.result.success) {
              this.$alert('您的提现申请已提交，会在1～3个工作日内进行审核打款，请耐心等待！', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  this.$router.go(-1)
                }
              });
            } else {
              if (res.data.result.message.indexOf("密码错误") !== -1) {
                this.$confirm('提现密码错误，请仔细核对密码是否正确！', '提示', {
                  confirmButtonText: '设置提现密码',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.$router.push(`/Financial/WalletAccount/Password?id=${this.accountDetail.id}`)
                }).catch(() => { });
              } else {
                this.$message.error(res.data.result.message)
              }
            }
            setTimeout(() => {
              this.loading = false
            }, 500)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // bankInfoSure() {
    //   this.$refs["bankInfoForm"].validate((valid) => {
    //     if (valid) {
    //       this.bankInfoVisible = false
    //     } else {
    //       console.log('error submit!!');
    //       return false;
    //     }
    //   })
    // },
    // bankInfoClose() {
    //   this.bankInfoVisible = false
    //   this.$refs.bankInfoForm.resetFields();
    // }
  },
};
</script>

<style scoped>
.card>>>.el-form-item__content {
  word-wrap: break-word;
}

.card>>>.el-card__body {
  padding: 0 10px;
  background: #f1f1f1;
}
</style>
